import React from 'react';
import { useT } from '@repo/common';
import RichText from './RichText';

const PerksAndBenefits = ({ job }) => {
  const t = useT();
  const perks = job?.perks?.trim();
  const benefits = job?.benefits?.trim();
  const combinedText = [perks, benefits].filter(Boolean).join('\n\n');

  // 미입력 시 섹션 숨김
  if (!combinedText) return null;

  return (
    <div>
      <div className='flex flex-col items-start py-[30px] w-full gap-2 tabletH:gap-4 text-text-primary '>
        <div className='typo-b18Strong self-stretch'>
          {t('Perks and benefits', '복리후생')}
        </div>

        <RichText text={combinedText} />
      </div>

      <div className='border-b border-grayscale-gray02' />
    </div>
  );
};

export default PerksAndBenefits;
